import { render, staticRenderFns } from "./RateHistory.vue?vue&type=template&id=da4bc7ae"
import script from "./RateHistory.vue?vue&type=script&lang=js"
export * from "./RateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports